import { createFileRoute } from "@tanstack/react-router";
import SaintBreakthroughEvent from "@/pages/SaintBreakthroughEvent";
export const Route = createFileRoute("/saint-breakthrough-event")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "SAINT® Breakthrough Depression Treatment Presentation | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Attend an exclusive presentation on the 5-day SAINT® protocol in South Florida and online. Limited to 10 guests. Pre-registration and admission ticket required.",
        },
        {
          property: "og:title",
          content:
            "SAINT® Breakthrough Depression Treatment Presentation | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Attend an exclusive presentation on the 5-day SAINT® protocol in South Florida and online. Limited to 10 guests. Pre-registration and admission ticket required.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/saint-breakthrough-event",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:image",
          content:
            "https://vibe.filesafe.space/1787327131284421342/attachments/4a35dd4b-e412-4773-9d8a-510c498c28a9.png",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-breakthrough-event",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintBreakthroughEvent />;
}
